<template>
    <div id="disputeDatesModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Compensation Dispute Milestones</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                    
                </div>
                <div class="modal-body">
                    <div v-if="document" class="font-weight-bold mb-3">{{ document.description }}</div>
                    <div v-if="message" class="alert alert-danger mb-3" role="alert">{{ message }}</div>                
                    <table class="table table-sm table-borderless">
                        <tr v-if="document">
                            <td class="fit">Uploaded/Created Date:</td>
                            <td>{{ document.created_at | localizeTime('MM/DD/YYYY') }}</td>
                        </tr>
                        <tr><td></td><td></td></tr>                                         
                        <tr>
                            <td class="fit">Filing Date:</td>
                            <td><input type="date" class="form-control form-control-sm" v-model="filingDate"></td>
                        </tr>
                        <tr>
                            <td class="fit">TSC Date:</td>
                            <td><input type="date" class="form-control form-control-sm" v-model="tscDate"></td>
                        </tr>
                        <tr>
                            <td class="fit">Trial Date:</td>
                            <td><input type="date" class="form-control form-control-sm" v-model="trialDate"></td>
                        </tr>                                                                                                 
                        <tr>
                            <td class="fit">Closing Date:</td>
                            <td><input type="date" class="form-control form-control-sm" v-model="closingDate"></td>
                        </tr>
                        <tr><td></td><td></td></tr>
                        <tr>
                            <td class="fit">Settlement Date:</td>
                            <td><input type="date" class="form-control form-control-sm" v-model="settlementDate" :disabled="dismissalDate ? true : false"></td>
                        </tr>
                        <tr><td></td><td></td></tr>
                        <tr>
                            <td class="fit">Dismissal Date:</td>
                            <td><input type="date" class="form-control form-control-sm" v-model="dismissalDate" :disabled="settlementDate ? true : false"></td>
                        </tr>                                               
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>                    
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
export default {
    data() {
        return {
            document: null,
            filingDate: null,
            tscDate: null,
            trialDate: null,
            settlementDate: null,
            dismissalDate: null,            
            closingDate: null,
            message: null
        }
    },
    methods: {
        showModal: function (document) {

            this.document = document;
            this.filingDate = document.filing_date;
            this.tscDate = document.trial_setting_conference_date;
            this.trialDate = document.trial_date;
            this.settlementDate = document.settlement_date;
            this.dismissalDate = document.dismissal_date;
            this.closingDate = document.closing_date;
            this.message = null;

            $('#disputeDatesModal').modal('show');
        },
        save: function () {

            if (this.validate()) {

                axios.patch('/ajax/attorney/claims/' + this.document.claim_id + '/disputes/' + this.document.id + '/milestones', {
                    filing_date: this.filingDate,
                    trial_setting_conference_date: this.tscDate,
                    trial_date: this.trialDate,
                    settlement_date: this.settlementDate,
                    dismissal_date: this.dismissalDate,
                    closing_date: this.closingDate
                })
                .then(response => {
                    $('#disputeDatesModal').modal('hide');
                })
                .catch(error =>  {
                    toastr['error'](error.response.data.message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });
            }
            else {

                this.message = 'Order of dates is not chronological.';
            }            
        },
        validate: function () {

            // create array of chronological dates removing any null dates
            const dates = [
                this.filingDate,
                this.tscDate,
                this.trialDate,
                this.closingDate
            ].filter(date => date);

            // must be at least 2 dates to compare
            if (dates.length > 1) {
                    
                for (let i = 0; i < dates.length; i++) {
                    if (dates[i +1] < dates[i]) {
                        return false;
                    }
                }
            }

            // TODO: can settlement or dismissal date occur at anytime?

            return true;
        }
    },    
    created() {
        eventHub.$on('show-attorney-dispute-dates', this.showModal);
    },
    beforeDestroy() {
        eventHub.$off('show-attorney-dispute-dates');
    }    
}
</script>

<style scoped>

</style>